import PropTypes from 'prop-types';
import { createContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { isUserLoggedIn, useLocalStorage } from 'utils/common';
import { sessionConfig } from 'utils/constant';

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const MainContext = createContext();

function MainProvider({ children }) {
  const { removeStorage, setStorage, getStorage } = useLocalStorage();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const currentLang = i18n.language;
  const upperCaseLang = currentLang.toUpperCase();
  const project = useSelector((state) => state.auth.project);
  const isLogin = isUserLoggedIn();
  const [rowSelected, setRowSelected] = useState();

  const value = {
    t,
    i18n,
    currentLang,
    upperCaseLang,
    dispatch,
    useSelector,
    useNavigate,
    useLocation,
    project,
    isLogin,
    rowSelected,
    setRowSelected
  };

  return <MainContext.Provider value={value}>{children}</MainContext.Provider>;
}

MainProvider.propTypes = {
  children: PropTypes.node
};

export { MainProvider, MainContext };
